import { Button, Flex } from '@driftt/dds'
import React from 'react'

import {
  StyledButtonContainer,
  StyledCard,
  StyledCardContent,
  StyledHeader,
  StyledIconContainer,
  StyledText,
} from './EmptyStateContainer.styles'
import { ReactComponent as QualDoc } from './qual-doc.svg'

interface Props {
  onCreatePersona: () => void
}

const EmptyStateContainer = ({ onCreatePersona }: Props) => {
  return (
    <Flex justifyContent="center" fullHeight fullWidth>
      <StyledCard>
        <StyledCardContent
          direction="column"
          fullHeight
          alignItems="center"
          justifyContent="center"
          gap={0}
        >
          <StyledIconContainer>
            <QualDoc />
          </StyledIconContainer>
          <StyledHeader>Get started with lead qualification</StyledHeader>
          <StyledText variant="subtitle1">
            Optimize your buyers' engagement by crafting personas that fit your
            definition of a qualified lead
          </StyledText>
          <StyledButtonContainer>
            <Button onClick={onCreatePersona}>Create persona</Button>
          </StyledButtonContainer>
        </StyledCardContent>
      </StyledCard>
    </Flex>
  )
}

export default EmptyStateContainer
